<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->


// === Easter Egg Display Window ===
window.easterEggConfig = {
  startDate: new Date("2025-04-03T00:01:00"),
  endDate: new Date("2025-04-04T20:00:00")
};

window.shouldShowEasterEgg = function () {
  const now = new Date();
  const { startDate, endDate } = window.easterEggConfig;
  return now >= startDate && now <= endDate;
};

// === Wait for Omnisend to Load, Then Attach Popup Triggers ===
function waitForOmnisendAndInit(attempt = 0) {
  const isReady = window.omnisend && typeof window.omnisend.push === 'function';

  if (isReady) {
    const eggButtons = document.querySelectorAll('[data-omnisend-form]');
    eggButtons.forEach(button => {
      button.addEventListener('click', function () {
        const formId = button.getAttribute('data-omnisend-form');
        if (formId) {
          window.omnisend.push(['openForm', formId]);
        }
      });
    });
  } else if (attempt < 20) {
    setTimeout(() => waitForOmnisendAndInit(attempt + 1), 300); // Retry ~6s
  } else {
    console.warn("Omnisend failed to load.");
  }
}

// === Hide Eggs If Outside the Date Window
function controlEggVisibility() {
  const shouldShow = window.shouldShowEasterEgg();
  const eggs = document.querySelectorAll('.relative-egg-wrapper, .centered-easter-egg');
  eggs.forEach(egg => {
    egg.style.display = shouldShow ? 'block' : 'none';
  });
}

// === Initialize on DOM Ready
document.addEventListener("DOMContentLoaded", function () {
  controlEggVisibility();
  waitForOmnisendAndInit();
});
